import {
  CloudArrowUpIcon,
  LockClosedIcon,
  ServerIcon,
} from "@heroicons/react/20/solid";
import ImarikaInvPlanTabs from "./ImarikaInvPlanTabs";
import Money from "../../assets/money.jpg"

const features = [
  {
    name: "Benefits:",
    description:
      "It is a low risk investment Suitable for two to three year investment horizon, Provides capital preservation and provides a stable income stream during the life of the investment",
  },

];

export default function BalancedBondFund() {
  return (
    <div>
      <div className="overflow-hidden bg-white py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
            <div className="lg:pr-8 lg:pt-4">
              <div className="lg:max-w-lg">
                <h2 className="text-base font-semibold leading-7 text-indigo-600">
                  Unit Trusts
                </h2>
                <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                  Balanced Fund
                </p>
                <p className="mt-6 text-lg leading-8 text-gray-600">
                  Our balanced fund, is a unit trust that invests in diversified
                  asset classes including fixed income assets, offshore,
                  property and equity. It provides investors with medium to long
                  term growth of their capital. It is a medium risk investment
                  vehicle and is suitable for a 3-5-year investment horizon. The
                  diversification boosts return by providing a cushion during a
                  down turn in one asset class.{" "}
                </p>

                <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                  Bond Plus Fund
                </p>
                <p className="mt-6 text-lg leading-8 text-gray-600">
                  This is an income fund which invests in a variety of bonds
                  including corporate bonds,treasury bonds and other fixed
                  income securities, minimizing the risk involved with investing
                  directly in bonds. It allows for immediate liquidity, giving
                  an edge over bonds in the market which are not easily disposed
                  off. The income fund looks to achieve a reasonable level of
                  current income with maximum stability for the capital
                  invested. The Fund is suitable for investors seeking a regular
                  income from their investment periodically, ideally after a 2 –
                  3-year period.
                </p>
                <dl className="mt-10 max-w-xl space-y-8 text-base leading-7 text-gray-600 lg:max-w-none">
                  {features.map((feature) => (
                    <div key={feature.name} className="relative ">
                      <dt className="inline font-semibold text-gray-900">
                        {feature.name}
                      </dt>{" "}
                      <dd className="inline">{feature.description}</dd>
                    </div>
                  ))}
                </dl>
              </div>
            </div>
            <img
              src={Money}
              alt="Product screenshot"
              className="w-[48rem] max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem] md:-ml-4 lg:-ml-0"
              width={2432}
              height={1442}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
